export default __webpack_public_path__ + "static/media/sweet3.c495c742.jpg";